import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        padding: "18px 20px",
        background: "linear-gradient(90deg, #1b5e20, #4caf50)",
        color: "#ffffff",
        textAlign: "center",
        fontSize: "15px",
        fontWeight: "500",
        boxShadow: "0 -2px 8px rgba(0,0,0,0.15)",
      }}
    >
      © {new Date().getFullYear()} Energy Club Programme — All Rights Reserved.
    </footer>
  );
};

export default Footer;
